import EmojiBlot from './formats/emoji-blot'
import ShortNameEmoji from './modules/emoji'
import ToolbarEmoji from './modules/toolbar-emoji'

export default { EmojiBlot, ShortNameEmoji, ToolbarEmoji }
